import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = (theme) => ({
    root: {
    },
    contentText: {
    }
});

const NoteDialog = (props) => {
    const { t, classes, isOpen, target, onClose, onSave } = props;
    const [open, setOpen] = useState(false);
    const [idx, setIdx] = useState(0);
    const [note, setNote] = useState('');

    useEffect(() => {
        if (target) {
            const { index, item } = target;
            setIdx(index);
            setNote(item.note);
        }
    }, [target]);

    const handleSave = () => {
        onSave(idx, note);
    };
    
    const handleClose = () => {
        onClose();
    };
    

    return (
        <>
            {
                target &&
                <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'sm'} aria-labelledby="note-edit-dialog">
                    <DialogTitle id="note-edit-dialog">檢視及編輯備註</DialogTitle>
                    <DialogContent>
                        <DialogContentText className={styles.contentText}>
                            <span style={{ color: '#ff8175' }}>說明與規劃不一致的理由</span>
                        </DialogContentText>
                        <TextField
                            fullWidth
                            id="note-content"
                            label="備註"
                            multiline
                            rows={6}
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            variant="outlined"
                        />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose} variant="outlined" color="primary">取消</Button>
                        <Button onClick={handleSave} variant="outlined" color="default">儲存</Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    );    
};

const mapStateToProps = state => ({
    ExtendSupReason: state.data.ExtendSupReason,
});

const mapDispatchToProps = dispatch => ({  
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(NoteDialog);
